<template>
  <div id="subirvideo">
    <div class="row">
      <div class="col-4">
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <b-form-group
            id="exa"
            label="Subcuenca"
            label-for="subcuenca"
            description="Id de la subcuenca"
          >
            <b-form-input
              id="subcuenca"
              v-model="form.subcuenca"
              type="text"
              required
              placeholder="SC"
            />
          </b-form-group>

          <b-form-group
            id="tramo"
            label="Tramo"
            label-for="formTramo"
            description="ID del tramo en que se grabo el video"
          >
            <b-form-input
              id="formTramo"
              v-model="form.tramo"
              type="text"
              required
              placeholder="Tramo"
            />
          </b-form-group>

          <b-form-group
            id="formcrea"
            label="Fecha"
            label-for="crea"
            description="Fecha en que se grabo el video"
          >
            <b-form-input id="crea" type="date" v-model="form.fecha" required />
          </b-form-group>
          <b-form-group
            id="formSent"
            label="Sentido de grabacion"
            label-for="sentido"
            description="Sentido en que se a grabado el video actual"
          >
            <b-form-select
              id="sentido"
              v-model="form.direccion"
              :options="optionsS"
              required
            />
          </b-form-group>
          <b-form-group
            id="formfile"
            label="Video"
            label-for="filev"
            description="Extenciones soportadas mp4 y avi"
          >
            <b-form-file
              id="filev"
              @change="uploadFieldChange"
              :state="Boolean(form.video)"
              v-model="form.video"
              placeholder="elija el video"
              drop-placeholder="Drop file here..."
              accept=".MP4,.mp4,.AVI,.avi"
              required
            />
          </b-form-group>
          <b-button type="submit" variant="primary">A la Lista</b-button>
          <b-button class="float-right" type="reset" variant="danger"
            >Limpiar</b-button
          >
        </b-form>
      </div>
      <div class="col-8">

        <vue-player
          v-if="rutaActual != ''"
          :src="rutaActual"
          width="640"
          height="360"
          controls
          :autoplay="true"
          preload
        ></vue-player>
        <b-form-file
          v-if="rutaActual != ''"
          accept="image/*"
          multiple
          v-model="form.imagen"
          ref="fileinput"
          class="mb-2"
        />
      </div>
      <div class="col-12">
        <hr style="border:2px;" />
        <table class="float-right">
          <tr>
            <td>
              <b-button
                @click="VerLista"
                variant="dark"
                size="lg"
                v-b-modal.modalxl
              >
                Ver Lista
              </b-button>
            </td>
            <td style="width: 15px"></td>
            <td>
              <b-button
                data-toggle="tooltip"
                data-placement="top"
                title="Subir video"
                size="lg"
                variant="success"
                @click="
                  () => {
                    UpVideo = [];
                    Subir();
                  }
                "
              >
                <span
                  style="width: 15px; height: 15px"
                  class="ti-cloud-up"
                ></span>
              </b-button>
            </td>
          </tr>
        </table>

        <b-modal
          id="modalxl"
          size="xl"
          title="Lista de videos "
          @ok="modal"
          ref="RefVideo"
        >
          <b-table hover :items="items">
            <vs-button
              slot="Actualizar"
              slot-scope="data"
              @click="Actualizar(data.value)"
            >
              <span class="ti-pencil-alt"></span>
            </vs-button>
            <vs-button
              slot="Eliminar"
              slot-scope="data"
              @click="Eliminar(data.value)"
            >
              <span class="ti-trash"></span>
            </vs-button>
          </b-table>
        </b-modal>
        <b-modal
          id="modallg"
          ref="refSubida"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
          title="Espera mientra se suben los videos"
          :hide-header-close="true"
          :hide-footer="true"
        >
          <table style="margin: 0 auto;">
            <tr v-for="(v, index) in UpVideo" :key="v.subcuenca">
              <td>
                <span v-if="upNow === index" class="ti-reload"></span>
                <span v-else class="ti-check-box"></span>
              </td>
              <td style="min-width: 100px">{{ v.nombre }}</td>
              <td>
                <b-progress
                  v-if="upNow === index"
                  :value="percentCompleted"
                  :max="100"
                  show-progress
                  animated
                  style="width: 400px"
                />
                <b-progress
                  v-else
                  :value="100"
                  :max="100"
                  style="width: 400px"
                />
              </td>
            </tr>
          </table>

          <b-button @click="hide" :disabled="upNow != null" class="float-right"
            >Aceptar</b-button
          >
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import NotificationTemplate from "./Notifications/NotificationTemplate";
import Store from "../store";
import Http from "../Http";
import Exito from "./Notifications/Exito";
import vuePlayer  from  '@algoz098/vue-player'
export default {
  name: "SubirVideos",
    components: {
        vuePlayer
    },
  data: () => ({
    percentCompleted: 0,
    upNow: null,
    form: {
      subcuenca: null,
      direccion: null,
      nombre: null,
      fecha: null,
      video: null,
      tramo: null,
      imagen: []
    },
    show: true,
    optionsS: [
      { value: null, text: "Elija una Opción" },
      { value: "A", text: "A" },
      { value: "B", text: "B" },
      { value: "A-2", text: "-2" },
      { value: "B-2", text: "B-2" }
    ],
    items: [],
    Formdata: new FormData(),
    rutaActual: "",
    videos: [],
    UpVideo: [],
    isUpdate: null
  }),
  mounted() {
    //this.$refs.refSubida.show();
  },
  methods: {
    hide() {
      this.$refs.refSubida.hide();
    },
    modal() {
      this.items = [];
    },
    uploadFieldChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        for (let i = files.length - 1; i >= 0; i--) {
          let allowedExtensions = /(.MP4|.mp4|.avi|.AVI)$/i;
          if (!allowedExtensions.exec(files[i].name)) {
            alert("extencion no permitida");
          } else {
            this.form.video = files[i];
            this.rutaActual = (window.URL || window.webkitURL).createObjectURL(
              this.form.video
            );
          }
        }
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.form.nombre = this.form.tramo + " " + this.form.direccion;
      if (this.isUpdate == null) {
        this.videos.push({
          subcuenca: this.form.subcuenca,
          direccion: this.form.direccion,
          nombre: this.form.nombre,
          fecha: this.form.fecha,
          video: this.form.video,
          tramo: this.form.tramo,
          imagen: this.form.imagen
        });
        this.$notify({
          component: Exito,
          icon: "ti-save",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success"
        });
      } else {
        this.videos[this.isUpdate].subcuenca = this.form.subcuenca;
        this.videos[this.isUpdate].direccion = this.form.direccion;
        this.videos[this.isUpdate].nombre = this.form.nombre;
        this.videos[this.isUpdate].fecha = this.form.fecha;
        this.videos[this.isUpdate].video = this.form.video;
        this.video[this.isUpdate].video = this.form.tramo;
        this.video[this.isUpdate].imagen = this.form.imagen;
        this.isUpdate = null;
        this.$notify({
          component: NotificationTemplate,
          icon: "ti-save",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success"
        });
      }
      this.clear();
    },
    clear() {
      this.show = false;
      this.form.subcuenca = null;
      this.form.direccion = null;
      this.form.nombre = null;
      this.form.fecha = null;
      this.form.video = null;
      this.form.tramo = null;
      this.rutaActual = "";
      this.form.imagen = [];
      this.isUpdate = null;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onReset(evt) {
      evt.preventDefault();
      this.clear();
    },
    Eliminar(index) {
      if (confirm("esta seguro que quiere sacar el video de la lista")) {
        this.videos.splice(index, 1);
        this.$refs.RefVideo.hide();
      }
    },
    Actualizar(index) {
      this.show = false;
      let tmp = this.videos[index];
      this.form.video = tmp.video;
      this.form.fecha = tmp.fecha;
      this.form.direccion = tmp.direccion;
      this.form.subcuenca = tmp.subcuenca;
      this.form.tramo = tmp.tramo;
      this.isUpdate = index;
      console.log(tmp.video.name);
      this.rutaActual = (window.URL || window.webkitURL).createObjectURL(
        this.form.video
      );
      this.$nextTick(() => {
        this.show = true;
      });
      this.$refs.RefVideo.hide();
    },
    VerLista() {
      this.modal();
      let i = 0;
      this.videos.forEach(v => {
        this.items.push({
          Nombre: v.nombre,
          Fecha: v.fecha,
          Sebcuenca: v.subcuenca,
          Actualizar: i,
          Eliminar: i
        });
        i++;
      });
    },
    Subir() {
      if (this.videos.length > 0) {
        this.$refs.refSubida.show();
        let form = new FormData();
        let user = Store.state.User.CurrentUser;
        let tmp = this.videos.shift();
        this.upNow = this.UpVideo.push(tmp) - 1;
        let data = {
          video_nombre: tmp.nombre,
          video_tramo: tmp.tramo,
          video_subcuenca: tmp.subcuenca,
          video_fechacreacion: tmp.fecha,
          user_id: user.user_id,
          region_id: user.region_id,
          video_sentido: tmp.direccion
        };
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: function(progressEvent) {
            this.percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            this.$forceUpdate();
          }.bind(this)
        };
        form.append("body", JSON.stringify(data));
        form.append("file", tmp.video);
        Http.Http()
          .post("Video", form, config)
          .then(resp => {
            console.log(resp);
            this.UpImagen(resp.data, tmp.imagen);
            this.percentCompleted = 0;
            setTimeout(this.Subir, 2000);
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.upNow = null;
      }
    },
    UpImagen(video_id, imagenes) {
      if (imagenes.length > 0) {
        let img = imagenes.pop();
        let data = new FormData();
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        data.append("imagen", img);
        Http.Http()
          .put(`Video/imagen/${video_id}`, data, config)
          .then(resp => {
            console.log(resp);
            this.UpImagen(video_id, imagenes);
          })
          .then(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>

<style scoped></style>
